import React, { useState, useEffect, useReducer } from "react";
import { Trash2, Edit, PlusCircle } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { calMaxPage } from "../../Common/Functions/CommonFunctions";

import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { HANDLE_ACTION } from "../../../../redux/actionTypes";
//import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import clipboard from "../../../../assets/images/Vedam/clipboard.png";
import Edit_SOC_category from "./Edit_SOC_category";
import {
  delete_soc,
  get_noc,
  get_noc_category,
  get_soc,
  get_soc_category,
  post_soc,
} from "../../../../api";
import { Typeahead } from "react-bootstrap-typeahead";
import Edit_SOC_Master from "./Edit_SOC_Master";
import SOC_tree_view from "./SOC_tree_view";

const schema = yup
  .object()
  .shape({
    name: yup
      .string()
      .required("SOC name is required !"),
    srno: yup
      .string()
      .max(30, "30 charaters allowed !")
      .matches(/^[a-zA-Z0-9]*$/, 'SR.No must be alphanumeric')
      .required("Sr.No is required"),
   // sequence: yup.string().required("sequence is required"),
    nocCategory: yup
      .array()
      .required("Please select NOC category !")
      .min(1, "Please select NOC category !"),
    // sequence: yup().string().required("Sequence is required !"),
  })
  .required();

function SOC_Master() {
  let navigate = useNavigate();
  const customer_id = localStorage.getItem("customer_id");

  const { register, handleSubmit, formState, control, reset } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  let { errors } = formState;

  const [modal8, setModal8] = useState();
  const [modal, setModal] = useState(false);
  const [visible, setVisible] = useState(false);

  const [srNo, setSrNo] = useState(0);
  const [totalRecords, setTotalRecords] = useState("");
  const [apiBySearch, setApiBySearch] = useState(false);
  const [dataForUpdate, setDataForUpdate] = useState({ data: {} });
  const [soc_category_list, setSoc_category_list] = useState({
    data: [],
    loading: false,
  });
  const [soc_parent_list, setSoc_parent_list] = useState({
    data: [],
    loading: false,
  });
  const [noc_category_list, setNoc_category_list] = useState({
    data: [],
    loading: false,
  });
  const [search,setSearch]=useState();

  const category_data = useLocation();
  //console.log(category_data.state.Id,"dataanov");
  const user = localStorage.getItem("user");

  const toggle8 = () => {
    //setModal8(!modal8);
    setVisible(!visible)
    if (visible === false || visible === undefined) {
      reset();
    }
  };
  const toggle = () => {
    setModal(!modal);
    if (modal === false || modal === undefined) {
      reset();
    }
  };

  const initialState = {
    loading: false,
    error: "",
    soc_list: [],
    itemsPerPage: 10,
    page: 1,
    maxPage: 0,
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case HANDLE_ACTION:
        return {
          page: action.page,
          itemsPerPage: action.itemsPerPage,
          loading: action.loading,
          error: action.error,
          soc_list: action.soc_list,
          maxPage: action.maxPage,
        };

      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    console.log("state", state);
    dispatch({
      type: HANDLE_ACTION,
      page: state.page,
      loading: true,
      error: state.error,
      soc_list: state.soc_list,
      itemsPerPage: state.itemsPerPage,
      maxPage: state.maxPage,
    });

    fetch_SOC_lists();
    fetch_NOC_Category();
    fetch_soc_parent();


  }, [state.page, state.itemsPerPage,]);


  function fetch_SOC_lists(para1) {
    dispatch({
      type: HANDLE_ACTION,
      page: para1 === "refresh" ? 1 : state.page,
      loading: true,
      error: state.error,
      soc_list: state.soc_list,
      itemsPerPage: state.itemsPerPage,
      maxPage: state.maxPage,
    });

    var reqPayload = {
      page: state.page,
      entriesPerPage: state.itemsPerPage,
      customer: customer_id,
      socCategoryId: category_data.state.Id,
    };

    if (para1 || search) {
      reqPayload = {
        page: state.page,
        entriesPerPage: state.itemsPerPage,
        searchVal: para1==undefined?search:para1,
        customer: customer_id,
        socCategoryId: category_data.state.Id,
      };
    }

    console.log("reqPayload",reqPayload)
    get_soc(reqPayload).then(
      (res) => {
        console.log("res_soc    ", res);
        console.log("calMaxPage(res.data.count)", calMaxPage(res.data.total));
        setTotalRecords(res.data.total);
        setSoc_parent_list({ data: res.data.payload, loading: false })
        dispatch({
          type: HANDLE_ACTION,
          page: state.page,
          loading: false,
          error: state.error,
          soc_list: res.data.payload,
          itemsPerPage: state.itemsPerPage,
          maxPage:
          (para1 !== "" && search!=="")
              ? calMaxPage(res.data.total)
              : calMaxPage(res.data.total),
          // Checking if user is searching customer, using above logic for pagination
        });
      },
      (err) => {
        console.log("err", err);

        if (err.response.status === 500) {
          toast.error("Something went wrong !", {
            autoClose: 3000,
            theme: "light",
          });
        }
      }
    );
  }

  // fetching the parents for soc's 
  function fetch_soc_parent() {
    let reqPayload = {
      customer: customer_id,
      socCategoryId: category_data.state.Id,
    };
    get_soc(reqPayload).then(
      (res) => {
        console.log("res_soc_parent    ", res);
        setSoc_parent_list({ data: res.data.payload, loading: false })

      },
      (err) => {
        console.log("err", err);

        if (err.response.status === 500) {
          toast.error("Something went wrong !", {
            autoClose: 3000,
            theme: "light",
          });
        }
      }
    );
  }



  //  feching noc_category

  function fetch_NOC_Category() {
    var reqPayload = {
      customer: customer_id,
    };

    get_noc_category(reqPayload).then(
      (res) => {
        console.log("res_noc    ", res);
        setNoc_category_list({ data: res.data.payload, loading: false });
      },
      (err) => {
        console.log("err", err);

        setNoc_category_list({ data: [], loading: true });
      }
    );
  }
  // Deleting customer
  const del_soc = (val) => {
    console.log("val", val);
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        // Firing delete api
        delete_soc({ Id: val.Id }).then(
          (res) => {
            console.log("res", res);
            toast.success("SOC  deleted successfully !", {
              autoClose: 3000,
              theme: "light",
            });

            if (state.soc_list.length == 1 && state.page !== 1) {
              dispatch({
                type: HANDLE_ACTION,
                page: state.page - 1,
                loading: state.loading,
                error: state.error,
                soc_list: state.soc_list,
                itemsPerPage: state.itemsPerPage,
                maxPage: state.maxPage,
              });
              setSrNo((prevC) => prevC - 10)
            } else {
              fetch_SOC_lists();
            }
          },
          (err) => {
            console.log("err", err);
            toast.error("Something went wrong !", {
              autoClose: 3000,
              theme: "light",
            });
          }
        );
      }
    });
  };

  const onSubmit = (data) => {
    if (data !== "") {
      console.log("data", data);

      const payload = {
        srno: data.srno,
        socCategoryId: category_data.state.Id,
        soc: data.name,
        parent: data.parent ? data.parent[0].soc : null,
        parentId: data.parent ? data.parent[0].Id : null,
        nocCategory: data.nocCategory[0].categoryName,
        nocCategoryId: data.nocCategory[0].Id,
       // sequence: data.sequence,
        customer: customer_id
      };

      console.log("payloadalnsd", payload);
      post_soc(payload).then(
        (res) => {
          console.log("res", res);
          toast.success("SOC  created successfully !", {
            autoClose: 3000,
            theme: "light",
          });
          //  toggle8();
          setVisible(false);
          fetch_SOC_lists();
          fetch_soc_parent();
        },
        (err) => {
          console.log("err", err);
          toast.error(err.response.data.message, {
            autoClose: 3000,
            theme: "light",
          });
        }
      );
    } else {
      errors.showMessages();
    }
  };

  return (
    <React.Fragment>
      <Edit_SOC_Master
        modal={modal}
        toggle={toggle}
        data={dataForUpdate.data}
        socCategoryId={category_data.state.Id}
        fetch_SOC_lists={fetch_SOC_lists}
        soc_list={soc_parent_list.data}
        noc_list={noc_category_list.data}
      />

      <div className="vdi_soc_list py-4 fontFamily">
        <div className="card">
          <div className="title bg-primary-blue" id="card_title">
            <p className="mb-0 f-24">
              <span
                onClick={() => {
                  navigate(-1);
                }}
                className="text-light me-2"
                style={{ fontSize: "20px", cursor: "pointer" }}
              >
                <i className="fa fa-arrow-circle-left"></i>
              </span>
              SOC Master
            </p>
          </div>
          <div className="card-body">


            <div className="row">
              <div className="d-flex justify-content-between">
                <div >
                  <input placeholder="Search" className="form-control"
                    onChange={(e) => {
                      setSearch(e.target.value)
                      fetch_SOC_lists(e.target.value);
                     
                    }}
                  />
                </div>

                <div className="d-flex justify-content-end mb-4">
                  <button
                    onClick={() => {
                      toggle8();
                      setVisible(true);
                    }}
                    style={{ fontSize: "16px " }}
                    className="btn btn-primary-blue"
                  >
                   Create New SOC
                  </button>
                </div>
              </div>



            </div>
            {state.loading ? (
              <div className="loader-box justify-content-center">
                <div className="loader">
                  <div className="line bg-dark"></div>
                  <div className="line bg-dark"></div>
                  <div className="line bg-dark"></div>
                  <div className="line bg-dark"></div>
                </div>
              </div>
            ) : state.soc_list.length > 0 ? (
              <div className="table-responsive " style={{ maxHeight: "70vh" }}>
                <table className="table table-striped table-bordered">
                  <thead className="thead-light">
                    <tr
                      className="f-18"
                      style={{
                        position: "sticky",
                        top: "0",
                        background: "white",
                      }}
                    >
                      {/* <th scope="col">{"#"}</th> */}
                      <th scope="col">{"Sr.No"}</th>
                      {/* <th scope="col">{"Sequence"}</th> */}
                      <th scope="col">{"SOC Name"}</th>
                      <th scope="col">{"Parent"}</th>
                      <th scope="col">{"NOC Category"}</th>
                      <th scope="col">{"Action"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.soc_list.map((val, i) => (
                      <tr key={i} className="f-16">
                        {/* <td>{i + 1+srNo}</td> */}
                        <td>{val.srno}</td>
                        {/* <td>{val.sequence}</td> */}
                        <td>{val.soc}</td>
                        <td>{!val.parent ? "NA" : val.parent}</td>
                        <td>{val.nocCategory}</td>
                        <td>
                          <Edit
                            onClick={() => {
                              dataForUpdate.data = val;
                              console.log("val", val);
                              setDataForUpdate({
                                ...dataForUpdate,
                                data: dataForUpdate.data,
                              });
                              toggle();
                            }}
                            style={{ color: "#313131" }}
                            id={"editToolTip" + i}
                            className="cursor_pointer "
                            height={"18px"}
                            width={"18px"}
                          />

                          <UncontrolledTooltip
                            placement="bottom"
                            target={"editToolTip" + i}
                          >
                            {"Edit SOC"}
                          </UncontrolledTooltip>

                          <Trash2
                            onClick={() => del_soc(val)}
                            id={"deleteToolTip" + i}
                            className="cursor_pointer ms-1"
                            height={"18px"}
                            width={"18px"}
                          />
                          <UncontrolledTooltip
                            placement="bottom"
                            target={"deleteToolTip" + i}
                          >
                            {"Delete SOC"}
                          </UncontrolledTooltip>
                          {
                            !val.parent ? <>
                              <SOC_tree_view
                                object={val}
                                socCategoryId={category_data.state.Id}
                                soc_parent_list={soc_parent_list}
                                noc_category_list={noc_category_list}
                                fetch_SOC_lists={fetch_SOC_lists}
                              />
                            </>

                              : <></>


                          }




                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : apiBySearch ? (
              <p className="text-danger mb-0 f-22 text-center mt-4">
                {"No SOC List Found !"}
              </p>
            ) : (
              <p className="text-danger mb-0 f-22 text-center mt-4">
                {"SOC List is empty"}
              </p>
            )}

            {state.loading ? null : (
              <div className="mt-4">
                <Pagination
                  aria-label="Page navigation"
                  className="pagination justify-content-end pagination-primary"
                >
                  <PaginationItem disabled={state.page === 1 ? true : false}>
                    <PaginationLink
                      className="cursor_pointer"
                      onClick={() => {
                        dispatch({
                          type: HANDLE_ACTION,
                          page: state.page - 1,
                          loading: state.loading,
                          error: state.error,
                          soc_list: state.soc_list,
                          itemsPerPage: state.itemsPerPage,
                          maxPage: state.maxPage,
                        });
                        setSrNo((prevC) => prevC - 10);
                      }}
                    >
                      {"Previous"}
                    </PaginationLink>
                  </PaginationItem>

                  <PaginationItem active>
                    <PaginationLink>{state.page}</PaginationLink>
                  </PaginationItem>

                  <PaginationItem
                    disabled={
                      state.page === state.maxPage || state.maxPage === 0
                        ? true
                        : false
                    }
                  >
                    <PaginationLink
                      last
                      onClick={() => {
                        dispatch({
                          type: HANDLE_ACTION,
                          page: state.page + 1,
                          loading: state.loading,
                          error: state.error,
                          soc_list: state.soc_list,
                          itemsPerPage: state.itemsPerPage,
                          maxPage: state.maxPage,
                        });
                        setSrNo((prevC) => prevC + 10);
                      }}
                      className="cursor_pointer"
                    >
                      {"Next"}
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>

                {/* <p className='f-14 text-muted float-end mt-1'>{`Total Records: ${totalRecords}`}</p> */}
                <div>
                  <div className="d-flex justify-content-end">
                    <p className="f-12 text-muted mt-1">{`${state.page} / ${state.maxPage} pages`}</p>
                  </div>
                  <div className="d-flex justify-content-end">
                    <p className="f-14 text-muted">{`Total Records: ${totalRecords}`}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal show={visible} onHide={() => setVisible(false)} size="lg" backdrop="static">
        <Modal.Header className="bg-primary-blue" closeButton>
          <Modal.Title > {"Create New SOC "}</Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label className="f-w-600 f-14">{"Sr. No"}</label>
              <input
                className={
                  errors.srno ? "form-control is-invalid" : "form-control"
                }
                type="text"
                name={`srno`}
                {...register(`srno`)}
                placeholder="Enter Sr.No*"
              />

              <span className="text-danger">{errors.srno?.message}</span>
            </div>
            {/* <div className="col-12 col-md-6 mb-2">
              <label className="f-w-600 f-14">{"Sequence"}</label>
              <input
                className={
                  errors.sequence ? "form-control is-invalid" : "form-control"
                }
                type="number"
                name={`sequence`}
                {...register(`sequence`)}
                placeholder="Sequence*"
              />

              <span className="text-danger">{errors.sequence?.message}</span>
            </div> */}
            <div className="col-12 col-md-6 mb-2">
              <label className="f-w-600 f-14">{"SOC Name"}</label>
              {/* <input
                className={
                  errors.name ? "form-control is-invalid" : "form-control"
                }
                type="text"
                name={`name`}
                {...register(`name`)}
                placeholder="Name*"
              /> */}
              <textarea
                className={
                  errors.name ? "form-control is-invalid" : "form-control"
                }
                type="text"
                name={`name`}
                {...register(`name`)}
                placeholder="Enter SOC Name*"
                rows={"2"}
              ></textarea>

              <span className="text-danger">{errors.name?.message}</span>
            </div>

            <div className="col-12 col-md-6 mb-2">
              <label className="f-w-600 f-14">{"Select Parent"}</label>
              <Controller
                name="parent"
                control={control}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Typeahead
                    id="basic-typeahead"
                    labelKey="soc"
                    multiple={false}
                    options={soc_parent_list.data}
                    loading={soc_parent_list.loading}
                    emptyLabel={
                      [].length > 0
                        ? "No matches found."
                        : "No Parents to select"
                    }
                    placeholder="Select Parent"
                    onChange={onChange}
                    onBlur={onBlur}
                  />
                )}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label className="f-w-600 f-14">{"NOC Category"}</label>
              <Controller
                name="nocCategory"
                control={control}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Typeahead
                    id="basic-typeahead"
                    labelKey="categoryName"
                    multiple={false}
                    options={noc_category_list.data}
                    loading={noc_category_list.loading}
                    placeholder="Select NOC Category"
                    onChange={onChange}
                    onBlur={onBlur}
                    // selected={value}
                    isInvalid={errors.nocCategory ? true : false}
                  />
                )}
              />
              <span className="text-danger">{errors.nocCategory?.message}</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary-blue"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default SOC_Master;
